import angular from 'angular';
import socialSecurityCardComponent from './socialSecurityCard.component';

import socialSecurityData from './socialSecurityData/socialSecurityData';

let socialSecurityCardModule = angular.module('socialSecurityCard', [
  socialSecurityData
])

.component('socialSecurityCard', socialSecurityCardComponent)

.name;

export default socialSecurityCardModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityCard/socialSecurityCard.js